export default __webpack_public_path__ + "static/media/avatar_m.6520b087.svg";